/* GOC Phase 1 (DRAFT): pickup-person field behavior.
 * Loaded once per page from theme.liquid so it keeps working after the cart drawer
 * is re-rendered via innerHTML (inline <script> tags injected that way do not run).
 * Uses document-level delegation, so a single attach covers the cart page and the drawer. */
(function () {
  if (window.__gocPickupField) return;
  window.__gocPickupField = true;
  var OTHER = 'Someone else will pick up';
  function rootOf(el) { return el.closest('[data-pickup-person]'); }
  function rootForForm(formId) { return document.querySelector('[data-pickup-person][data-pickup-form="' + formId + '"]'); }
  function save(r) {
    var who = r.querySelector('[data-pickup-who]').value;
    var name = r.querySelector('[data-pickup-name]').value.trim();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Pickup person': who, 'Pickup name': who === OTHER ? name : '' } })
    }).catch(function () {});
  }
  function guard(e, formId) {
    var r = rootForForm(formId);
    if (!r) return;
    var other = r.querySelector('[data-pickup-who]').value === OTHER;
    var input = r.querySelector('[data-pickup-name]');
    if (other && !input.value.trim()) {
      e.preventDefault();
      e.stopPropagation();
      r.querySelector('[data-pickup-name-wrap]').hidden = false;
      r.querySelector('[data-pickup-error]').hidden = false;
      input.focus();
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var sel = t.closest('[data-pickup-who]');
    var nm = t.closest('[data-pickup-name]');
    if (!sel && !nm) return;
    var r = rootOf(t);
    var wrap = r.querySelector('[data-pickup-name-wrap]');
    var input = r.querySelector('[data-pickup-name]');
    var other = r.querySelector('[data-pickup-who]').value === OTHER;
    wrap.hidden = !other;
    if (!other) input.value = '';
    r.querySelector('[data-pickup-error]').hidden = true;
    save(r);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#checkout, #CartDrawer-Checkout');
    if (!b) return;
    guard(e, b.id === 'CartDrawer-Checkout' ? 'CartDrawer-Form' : 'cart');
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.id !== 'cart' && f.id !== 'CartDrawer-Form')) return;
    guard(e, f.id);
  }, true);
})();
